import React, { createContext, useContext, useState } from 'react';

const defaultAppContext = {
  sidebarOpen: false,
  toggleSidebar: () => {},
};

const LandingAppContext = createContext(defaultAppContext);

export const useLandingAppContext = () => useContext(LandingAppContext);

export const LandingAppProvider = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(prev => !prev);
  };

  return (
    <LandingAppContext.Provider
      value={{
        sidebarOpen,
        toggleSidebar,
      }}
    >
      {children}
    </LandingAppContext.Provider>
  );
};

export default LandingAppContext;
